import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles/globals.css';
import './i18n';
import { installStaleBuildReload } from './lib/staleBuild';

// A tab from before a deploy reloads once when a screen's file of its old build is gone (lib/staleBuild.ts).
installStaleBuildReload();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
